<template>
    <el-dialog :visible.sync="visible" class="peiso-modal eod-modal" width="1028.045px">
        <div>
            <el-tabs v-model="activeTab" :stretch="true" @tab-click="handleActiveTab">
                <el-tab-pane label="Lunch" name="lunch" id="lunch">
                    <template v-if="isLoadingEod">
                        <div class="eodLoading d-flex justify-content-center align-items-center text-center">
                            <div>
                                <i class="el-icon-loading"></i>
                                <h6>Loading {{ activeTab }} Data...</h6>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <eod-form
                            v-if="activeTab == 'lunch'"
                            ref="eodLunch"
                            :type="activeTab"
                            :info="info"
                            :venueType="venueType"
                            :actualRosteredCapture="actualRosteredCapture"
                            :weeklyData="weeklyData"
                            :targetLabourData="targetLabourData"
                            :actualLabourCost="actualLabourCost"
                            :total="total"
                            :weeklyFullTimeCost="weeklyFullTimeCost"
                            :weeklyDay="weeklyDay"
                            :eodHistory="eodHistoryLunchData"
                            :actual="actual"
                            :employeeVariance="employeeVariance"
                            :isSaveGenerate="isSaveGenerate"
                            :settings="settings"
                            @generate-report="generateReport"
                            @refresh-eod="refreshOpenEod"
                            @closeDialog="closeEod"
                            :isCurrentDay="isCurrentDay"
                        />
                    </template>

                </el-tab-pane>
                <el-tab-pane label="Dinner" name="dinner" id="dinner">
                    <template v-if="isLoadingEod">
                        <div class="eodLoading d-flex justify-content-center align-items-center text-center">
                            <div>
                                <i class="el-icon-loading"></i>
                                <h6>Loading {{ activeTab }} data...</h6>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <eod-form
                            v-if="activeTab == 'dinner'"
                            ref="eodDinner"
                            :type="activeTab"
                            :venueType="venueType"
                            :info="info"
                            :actualRosteredCapture="actualRosteredCapture"
                            :weeklyData="weeklyData"
                            :targetLabourData="targetLabourData"
                            :actualLabourCost="actualLabourCost"
                            :total="total"
                            :weeklyFullTimeCost="weeklyFullTimeCost"
                            :weeklyDay="weeklyDay"
                            :eodHistory="eodHistoryDinnerData"
                            :actual="actual"
                            :employeeVariance="employeeVariance"
                            :isSaveGenerate="isSaveGenerate"
                            :settings="settings"
                            @generate-report="generateReport"
                            @refresh-eod="refreshOpenEod"
                            @closeDialog="closeEod"
                            :isCurrentDay="isCurrentDay"
                        />
                    </template>
                </el-tab-pane>
              </el-tabs>
        </div>
        <div class="button-container w-100 d-flex justify-content-center">
            <el-button v-if="!isLoading" :disabled="isLoadingEod" type="peiso-border-button" @click="getCurrentLabour()">Send Report</el-button>
            <el-button v-if="isLoading" type="peiso-border-button" class="cursor-disable" :disabled="isEodEnable">Sending report...</el-button>
            <!-- <el-button type="peiso-border-button" @click="getCurrentLabour()">Refresh total</el-button> -->
        </div>
    </el-dialog>
</template>

<style lang='scss'>
    @import 'static/scss/fonts/fonts.scss';
    @import "static/scss/scrollbar.scss";
    .eod-modal {
        .eodLoading {
            height: 200px !important;
            h6 {
                font-size: 15px;
                color: var(--text-color);
                margin-top: 10px;
            }
        }
        .el-icon-loading{
            font-size: 30px;
            color: var(--text-color);
        }
        .uppecase {
            text-transform: uppercase !important;
        }

        .el-tabs__item {
            color: var(--text-color);
            font-size: 20px;
            font-weight: 600;
            &:hover {
                color: #ffffffd0;
            }
        }


        .el-tabs__item.is-active {
            color: #EA3796;
        }

        .el-tabs__active-bar {
            background-color: #EA3796;
        }

        .el-tabs__content {
            max-height: 70vh !important;
            overflow-y: auto !important;
            padding: 30px 10px;
            &::-webkit-scrollbar {
                @extend .scrollbar;
            }

            &::-webkit-scrollbar-track {
                @extend .scrollbar-track;
            }

            &::-webkit-scrollbar-thumb {
                @extend .scrollbar-thumb;
            }
        }

        .upload-icon__image {
            padding: 10px;
            height: 350px;
            object-fit: cover;
            max-width: 100%;
        }
        .upload-con {
            width: 100%;
            min-height: 200px !important;
            max-height: 450px !important;
            background: var(--background-color-3);
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            position: relative;
            text-align: center;


            .el-upload-dragger  {
                min-height: 200px !important;
                max-height: 450px !important;
            }


            .el-upload-list__item{
                padding: 10px;
                background-color: var(--background-color-3) !important;
            }

            .el-icon-document {
                font-size: 20px;
                color: var(--text-color);
            }

            .el-upload-list__item .el-icon-close {
                display: block;
                position: absolute;
                top: 16px;
                font-size: 20px;
                right: 14px;
                cursor: pointer;
                opacity: .75;
                color: var(--text-color);
            }

            .el-upload-list__item-name {
                color: var(--text-color);
                display: block;
                margin-right: 40px;
                overflow: hidden;
                font-size: 16px;
                padding-left: 4px;
                text-overflow: ellipsis;
                -webkit-transition: color .3s;
                transition: color .3s;
                white-space: nowrap;
                text-align: left;
            }

            .demo {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                bottom: 0;
            }

            .el-upload {
                width: 100% !important;
                position: relative;
                display: inline-block;
                text-align: center;
                cursor: pointer;
                outline: 0;
            }



            .text {
                font-size: 18px;
                line-height: 28px;
                text-align: center;
                color: var(--text-color);
                margin: 0;
                padding: 0;
                font-weight: normal;
                word-break: break-word;
                small {
                    font-size: 18px;
                    color: var(--primary-color);
                }
            }

            .icon {
                display: block;
                width: 100%;
                height: 35px;
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center center;
                background-image: url("../../assets/upload.png");
                margin-bottom: 50px;
                position: relative;
                top: 30px;
            }

        }



        .el-dialog__body {
            display: flex;
            flex-direction: column;
            padding: 0px !important;

            .eod-modal-container {

                height: 100%;
                padding: 2rem !important;

                display: flex;
                flex-direction: column;
                gap: 20px;

                .header {
                    @include montserrat-font(20px, 120%, 700, $white);
                    margin-bottom: 16px;

                    &.subheaders {
                        margin-bottom: 0px;
                        margin-top: 10px;
                    }

                    .notes {
                        font-size: 14px;
                        letter-spacing: 0.5px;
                        color: $red;
                    }
                }

                .revenue-labour-container {
                    display: flex;
                    gap: 1rem;
                    .wrapper {
                        width: 100%;

                        .content {
                            display: flex;
                            border: 1px solid #5F5F5F;
                            .label, .value {
                                word-break: normal;
                                width: 100%;
                                padding: 10px 1rem;
                                @include montserrat-font(16px, normal, 500, $white);
                            }

                            .value {
                                border-left: 1px solid #5F5F5F;
                                text-align: right;
                            }

                            &:not(:first-child) {
                                border-top: none;
                            }

                            &.total {
                                .value, .label {
                                    font-weight: 700;

                                }

                                .value {
                                    color: $green;

                                    &.red {
                                        color: $red;
                                    }
                                }
                            }

                        }
                    }
                }

                .input-container {
                    span {
                        @include montserrat-font(16px, normal, 700, $white) {
                            margin-bottom: 10px;
                            display: block;
                        }
                    }

                    .cash-relate-container {
                        display: flex;
                        gap: 10px;

                        .input {
                            width: 100%;

                            input {
                                text-align: center;
                            }

                            .text-indicator {
                                @include montserrat-font(12px, normal, 500, $white) {
                                    padding: 5px;
                                    letter-spacing: 0.5px;
                                }
                            }
                        }

                    }
                }



                .el-textarea__inner, .el-input__inner {
                    @include montserrat-font(14px, normal, 400, $white);

                }

                .el-input__inner {
                    font-weight: 500;
                }

                .comp.peiso-input-default {
                    .el-input__inner {
                        height: 50px !important;
                        text-align: right;
                        padding: 7px;

                    }

                    .el-input__prefix {
                        display: flex !important;
                        align-items: center !important;
                    }
                }
            }

            .button-container {
                display: flex;
                justify-content: center;
                padding: 1.5rem;

                .el-button--peiso-border-button {
                    width: 380px;
                }
            }
        }

        .weather {
            .el-textarea__inner {
                text-transform: capitalize;
            }
        }
    }

</style>

<script>
    import utils from '../../utils/utils'
    import eodForm from './eodForm.vue'
    export default {
        components: {
            eodForm
        },
        data() {
            return {
                activeTab: 'lunch',
                visible: false,
                isLoading: false,
                isEodEnable: false,
                eodHistoryLunchData: null,
                eodHistoryDinnerData: null,
                venueType: '',
            }
        },
        props: {
            isLoadingEod: {
                default: false
            },
            show: {
                default: false
            },
            info: {
                default: null
            },
            employeeVariance: {
                default: []
            },
            actual: {
                default: 0
            },
            eodHistory: {
                default: null
            },
            targetLabourData: {
                default: null,
            },
            weeklyData: {
                default: null,
            },
            weeklyDay: {
                default: null,
            },
            weeklyFullTimeCost: {
                default: null,
            },
            actualLabourCost: {
                default: 0,
            },
            total: {
                default: ''
            },
            isSaveGenerate: {
                default: false
            },
            actualRosteredCapture: {
                default: null
            },
            settings: {
                default: null
            },
            isCurrentDay: {
                default: 0
            },
            calculatedRevenue: {
                default: 0
            }
        },
        watch: {
            activeTab() {
                if (this.isChangeActive) {
                    this.isChangeActive = !this.isChangeActive
                    return
                }
                this.$emit('eod-change', this.activeTab)
            },
            show(val) {
                this.visible = val
                if (!val) {
                    this.isChangeActive = true
                    this.activeTab = 'lunch'
                }
            },

            visible(val) {
                if (!val) {
                    this.$emit('closeDialog')
                    // this.activeTab = 'lunch';
                }
                // this.labourCost = this.labourCostTotal()
            },

            eodHistory() {
                // this.$refs.eodLunch.eodHistory = this.eodHistory;
                // this.$refs.eodDinner.eodHistory = this.eodHistory;
                setTimeout(() => {
                    if (this.activeTab == 'lunch') {
                        // this.$refs.eodLunch.eodHistory = this.eodHistory;
                        this.eodHistoryLunchData = this.eodHistory
                    }

                    if (this.activeTab == 'dinner') {
                        // this.$refs.eodDinner.eodHistory = this.eodHistory;
                        this.eodHistoryDinnerData = this.eodHistory
                    }
                }, 1000);

            },

            calculatedRevenue(val) {
            if (val) {
                this.weekToDatePercentage = utils.percentageTotal(this.weekToDate, val)
            }
            }
        },
        computed: {


        },
        methods: {
          checkFoHOrBoH(str) {
                // Convert the string to lowercase
                const lowerStr = str.toLowerCase();

                const foh = 'foh';
                const boh = 'boh';

                if (lowerStr.includes(foh)) {
                    return foh;
                } else if (lowerStr.includes(boh)) {
                    return boh;
                } else {
                    return '';
                }
            },

            refreshOpenEod() {
                this.$emit('refresh-eod')
            },

            generateReport(payload, type) {
                this.$emit('generate-report', payload, this.activeTab)
                this.isLoading = false;
            },

            closeEod() {
                this.$emit('closeDialog')

                this.activeTab = 'lunch';
            },

            handleActiveTab() {

            },

            getCurrentLabour(){
                this.isLoading = true;
                if (this.activeTab == 'lunch')  {
                    this.$refs.eodLunch.getCurrentLabour()
                    console.log('this.$refs.eodLunch: ', this.$refs.eodLunch);
                } else {
                    this.$refs.eodDinner.getCurrentLabour()
                    console.log('this.$refs.eodDinner: ', this.$refs.eodDinner);
                }

            },

        },
        mounted() {
          const venueName = sessionStorage.getItem('subVenueName');
          this.venueType =  this.checkFoHOrBoH(venueName);
        }
    }
</script>






// WEBPACK FOOTER //
// src/components/common/eod.vue